import { render } from "./CertificateValidation.vue?vue&type=template&id=553ec0b5"
import script from "./CertificateValidation.vue?vue&type=script&lang=js"
export * from "./CertificateValidation.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/megaluzz-admin/megaluzz-admin/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__